module.exports = __webpack_public_path__ + "img/G8.e8bda453.jpg";